export default "__VITE_ASSET__0d79508d__$_?nuxt_component=async__"